import request from '@/request'

export function addAmp(res)
{
    return request({
        url:'/amp/addAmp',
        method:'post',
        data:res,
    })
}